// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"647":"8041a075","684":"03a681fb"}[chunkId] + ".chunk.js";
};